/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type { PasswordStrengthRequestV2, PasswordStrengthResponseV2 } from '../dto'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class ApiPasswordStrengthControllerV2<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags api-password-strength-controller-v-2
   * @name CheckPasswordStrength2
   * @request POST:/api/v2/password-strength
   */
  checkPasswordStrength = (data: PasswordStrengthRequestV2, params: RequestParams = {}) =>
    this.http.request<PasswordStrengthResponseV2, any>({
      path: `/v2/password-strength`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static checkPasswordStrengthPath = '/v2/password-strength'
  static checkPasswordStrengthMethod = 'POST'
}
